export default __webpack_public_path__ + "static/media/poster.d094dfef.png";